import React from 'react'
import StaticCmsPage from '../../components/nemonto/StaticCmsPage'

const TermsofService = () => (
    <StaticCmsPage slug="terms-of-use" title="Terms of Use" subtitle="The rules for using Nemonto." />
)

export default TermsofService
